<template>
  <v-card v-if="isVisible" v-bind="$attrs">
    <v-system-bar>Kontakt per E-Mail</v-system-bar>
    <v-card-text v-if="$_isPerson(person)">
      <ListItem
        v-for="(distributionList, index) in distributionLists"
        :key="index"
        :title="distributionList.description"
      >
        <span>
          {{ joinEmails(distributionList.emails) }}
        </span>
        <template v-slot:action>
          <CopyButton :value="joinEmails(distributionList.emails)" />
        </template>
      </ListItem>
    </v-card-text>
    <v-card-text v-else>
      <v-chip-group column>
        <EmailChip
          v-for="(distributionList, index) in distributionLists"
          :key="index"
          :title="distributionList.description"
          :value="joinEmails(distributionList.emails)"
        />
      </v-chip-group>
    </v-card-text>
  </v-card>
</template>
<script>
import { defineComponent } from "vue";
import CopyButton from "common/components/CopyButton.vue";
import EmailChip from "common/components/EmailChip.vue";
import ListItem from "@/components/ListItem.vue";
import { joinEmails } from "common/utils/helper.js";

export default defineComponent({
  name: "ContactEmail",
  components: { EmailChip, ListItem, CopyButton },
  props: {
    person: { type: Object, default: null },
  },
  data() {
    return {
      distributionLists: [],
    };
  },
  computed: {
    hasPerson() {
      return this.person && this.person.id;
    },
    isVisible() {
      return this.hasPerson && this.distributionLists.length > 0;
    },
  },
  watch: {
    person() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    joinEmails,
    async fetchData() {
      this.distributionLists = [];
      if (!this.hasPerson) return;
      this.distributionLists = await this.apiGet({
        resource: "person/email",
        id: this.person.id,
      });
    },
  },
});
</script>
